import { type Query, QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

declare module "@tanstack/react-query" {
  interface Register {
    queryMeta: {
      /** Toasted when the read fails with nothing of it on screen yet. */
      loadErrorToast?: string;
    };
  }
}

/**
 * A screen that toasts its load failure says so once, when there is nothing to
 * show: a failed background re-read (focus, reconnect) leaves the answer on
 * screen and stays quiet, and a read the screen has already left (a property
 * switch, a back) is nobody's to report.
 */
function toastLoadError(
  _error: unknown,
  query: Query<unknown, unknown, unknown>
): void {
  const message = query.meta?.loadErrorToast;
  if (
    message &&
    query.state.data === undefined &&
    query.getObserversCount() > 0
  ) {
    toast.error(message);
  }
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError: toastLoadError }),
  });
}
